import { Text } from '@chakra-ui/react'

import ModalV3 from '@/components/UI/Modal/ModalV3'
import UserReviewRejectedText from '@/components/UserReview/UserReviewRejectedText'

import type { ModalState } from './types'

export default function AppContextModalRejected({
  modalState,
  hideModal,
}: {
  modalState: ModalState | null
  hideModal: () => void
}): React.ReactElement {
  return (
    <ModalV3
      open
      size="lg"
      onClose={hideModal}
      title="Account Rejected"
      body={() => (
        <Text>
          <UserReviewRejectedText actionName={modalState?.actionName} />
        </Text>
      )}
    />
  )
}
